import React, { useState } from "react";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";

import TertiaryBill from "./TertiaryBill";
import Equipments from "./Equipments";
import Structure from "./Structure";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Categories from "./Categories";
import Patrimoine from "./Patrimoine";
import Declaration from "./Declaration";
import Dashboard from "./Dashboard";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
    textTransform: "none",
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
  tabPanel: {
    padding: "0",
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>{children}</>

      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function VerticalTabsTertiaryBill(props) {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={2} lg={2}>
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleTabChange}
            aria-label="Vertical tabs example"
            className={classes.tabs}
            TabIndicatorProps={{ style: { background: "#91C73C" } }}
          >
            <Tab className={classes.tab} label="Tableau de bord" {...a11yProps(0)} />
            <Tab className={classes.tab} label="Assujetissement" {...a11yProps(1)} />
            <Tab className={classes.tab} label="Patrimoine - DT" {...a11yProps(2)} />
            <Tab className={classes.tab} label="Catégories" {...a11yProps(3)} />
            <Tab className={classes.tab} label="Equipements" {...a11yProps(4)} />
            <Tab className={classes.tab} label="Structure" {...a11yProps(5)} />
            <Tab className={classes.tab} label="Déclarations" {...a11yProps(6)} />
          </Tabs>
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={10}>
          <TabPanel value={value} index={0} className={classes.tabPanel} >
            <Dashboard />
          </TabPanel>
          <TabPanel value={value} index={1} className={classes.tabPanel} >
            <TertiaryBill />
          </TabPanel>
          <TabPanel value={value} index={2} className={classes.tabPanel} >
            <Patrimoine />
          </TabPanel>
          <TabPanel value={value} index={3} className={classes.tabPanel} >
            <Categories />
          </TabPanel>
          <TabPanel value={value} index={4} className={classes.tabPanel} >
            <Equipments />
          </TabPanel>
          <TabPanel value={value} index={5} className={classes.tabPanel} >
            <Structure />
          </TabPanel>
          <TabPanel value={value} index={6} className={classes.tabPanel} >
            <Declaration />
          </TabPanel>
        </GridItem>
      </GridContainer>
    </div>
  );
}
